import { render, staticRenderFns } from "./ResponsiveModal.vue?vue&type=template&id=656cdefb&scoped=true&"
import script from "./ResponsiveModal.vue?vue&type=script&lang=js&"
export * from "./ResponsiveModal.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveModal.vue?vue&type=style&index=0&id=656cdefb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656cdefb",
  null
  
)

export default component.exports